(function(global) {
	"use strict";

	function initParams() {
		var app = global.searchApp;
		var params = location.search.replace(/^\?/, "").split("&");
		var resultMode = "list";
		var cond = {};
		var hasCondition = false;

		params.forEach(function(param) {
			var pair = param.split(/=/), name, value;
			name = pair[0];
			value = (pair.length === 0) ? true : pair[1];

			if (name === "mode") {
				switch (value) {
				case "map":
				case "list":
					resultMode = value;
				}
			} else if (/^has_\w+$/.test(name)) {
				cond[name] = value;
				hasCondition = true;
			}
		});

		if (hasCondition) {
			// app.cond = cond;
			switch (resultMode) {
			case "map":
				app.showResultsMap(cond);
				break;
			case "list":
				app.showResultsList(cond);
				break;
			}
		}
	}

	global.searchAppInitParams = initParams;

})(window);
